/**
 * A global namespace for `hover` event.
 */
const mousehoverEvent = 'hover';
export default mousehoverEvent;
